import module from 'nominas/nomina/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class NominasNominaColaboradoresResumenExtendidoComponent {
  data
  onClose
  deducciones = []
  percepciones = []

  constructor ($catalogos) {
    this.$catalogos = $catalogos
  }

  $onInit () {
    this.$promise = this.$catalogos.get('movimientos')
      .then((data) => {
        let conceptos = orderBy(data, ['concepto'])

        this.percepciones = conceptos.filter((item) => item.naturaleza === 'P' && this.data.percepciones[item.id] > 0)
        this.deducciones = conceptos.filter((item) => item.naturaleza === 'D' && this.data.deducciones[item.id] > 0)
      })
  }
}

module.component('nominasNominaColaboradoresResumenExtendido', {
  controller: NominasNominaColaboradoresResumenExtendidoComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/resumen/extendido/component.js